'use client';

import { forwardRef, useContext } from 'react';

import { cx } from '@/styled-system/css';

import { Icon } from '../icon/icon';
import { ToggleButtonRootContext } from './context/toggle-button-root.context';
import { toggleButtonIconRecipe } from './styles/toggle-button-icon.styles';
import type { ToggleButtonIconPropsInterface } from './types/toggle-button-icon.types';

/**
 * @since 10.0.0
 */
export const ToggleButtonIcon = forwardRef<SVGSVGElement, ToggleButtonIconPropsInterface>(
  (props: ToggleButtonIconPropsInterface, forwardedRef) => {
    const {
      disabled = false,
      size = 'sm',
      selected = false,
      loading = false,
    } = useContext(ToggleButtonRootContext);
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="ToggleButton.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size={size === 'sm' ? 'sm' : 'md'}
        css={{
          ...toggleButtonIconRecipe.raw({ disabled, selected, loading }),
          ...cssProp,
        }}
        {...rest}
        className={cx('c11n_toggle-button__icon', rest.className)}
      >
        {children}
      </Icon>
    );
  },
);

ToggleButtonIcon.displayName = 'ToggleButton.Icon';
